type Params = {
  operatorName: string;
  text: string;
  timeout?: number;
};
const ICON = "https://next.rshb.ru/login/favicon.ico";

export const showNotification = async ({
  operatorName,
  text,
  timeout = 5000,
}: Params) => {
  const sendNotification = () => {
    const tag = `${new Date()}-${operatorName}`;
    const notification = new Notification(operatorName, {
      body: text,
      icon: ICON,
      tag,
    });

    setTimeout(() => notification.close(), timeout);
  };

  let permission = Notification.permission;

  if (permission === "granted") {
    sendNotification();
  } else if (permission === "default") {
    try {
      permission = await Notification.requestPermission();
      if (permission === "granted") {
        sendNotification();
      }
    } catch (error) {
      console.error("Error requesting notification permission:", error);
    }
  }
};
